import { render, staticRenderFns } from "./LifelongVipDiscount.vue?vue&type=template&id=11a23a9f&scoped=true&"
import script from "./LifelongVipDiscount.vue?vue&type=script&lang=js&"
export * from "./LifelongVipDiscount.vue?vue&type=script&lang=js&"
import style0 from "./LifelongVipDiscount.vue?vue&type=style&index=0&id=11a23a9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a23a9f",
  null
  
)

export default component.exports